module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_japan.62b9a647.pdf";